export default "/assets/images/social-twitter.svg";